var _style, _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGestionDePromociones = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.3,316.4c-13.8-23.9-26.9-46.5-40.9-70.8c88.5-51.8,146.2-128.6,180.4-226.3 c49.1,85,97.1,168.2,146.3,253.4C340,254.7,245.1,264.6,155.3,316.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124,346.1c18.2-11.7,35.1-22.5,53-34c5.2,8.8,10,16.7,14.5,24.6c20.3,35.1,40.6,70.2,60.8,105.4 c8.8,15.3,7.7,18.5-7.7,27.6c-8,4.7-16.2,9.2-24.2,14c-8.5,5.1-14.9,3.4-19.9-5.1C175.4,435.1,150.3,391.6,124,346.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7,249.5c13.5,23.3,27,46.6,40.8,70.5c-11.9,8.7-23,17.2-34.6,25c-3.2,2.1-8,2.6-12,2.7 c-18.4,0.3-30.7-9.8-39.5-24.8c-8.9-15-11.3-30.8-2-46.4c2.7-4.5,7.4-8.4,12.1-10.9C83.6,259.7,95.3,255,107.7,249.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M394.3,176.4c-13.4-23.2-26.2-45.3-39-67.4c17.7-8,37.3-1.7,47.8,14.7C414,140.4,410.9,161.4,394.3,176.4z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGestionDePromociones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gestion_de_promociones.f4a4d3f2.svg";
export { ForwardRef as ReactComponent };